// noinspection DuplicatedCode
import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";

import { Colors } from "../../../assets/Colors";
import { Card } from "@material-tailwind/react";
import { HrdInputGenerator } from "../../../components/form/HrdInputGenerator";
import { useForm } from "../../../components/isRequired";
import { useMutation } from "@tanstack/react-query";
import { fetchPostSilance } from "../../../fetchers";
import { toast } from "react-toastify";
import { maxPageGlobal } from "../../../assets/config";
import { BukuBankReportTable } from "../../../components/tablecard/DynamicTable";

// Halaman Buku Bank — desain & metode filter disamakan dengan Buku Besar
// (filter Bulan + COA, pagination server-side), TANPA filter Bisnis Unit
// (laporan lintas BU karena satu rekening bank dipakai semua BU).
const ReportBukuBank = ({}) => {
  let initialState = {
    Bulan: new Date(),
    DetailAccount: "",
  };

  const validations = [];

  const { values, errors, touched, customHandler } = useForm(
    initialState,
    validations
  );

  const mutationData = useMutation((param) =>
    fetchPostSilance("Accounting/BukuBank", param)
  );
  const [count, setCount] = useState(maxPageGlobal);
  const [start, setStart] = useState(0);
  const [param, setParam] = useState({
    start: start,
    count: count,
    search: "",
    Bulan: (new Date().getMonth() + 1).toString(),
    Tahun: new Date().getFullYear().toString(),
    DetailAccount: "",
  });

  useEffect(() => {
    toast.info("Loading table!", {
      position: "top-center",
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      draggable: true,
      theme: "light",
    });

    mutationData.mutate(param);
  }, [param]);

  const filterApi = () => {
    // Filter baru selalu kembali ke halaman pertama.
    setStart(0);
    setParam({
      start: 0,
      count: count,
      search: "",
      Bulan: (new Date(values.Bulan).getMonth() + 1).toString(),
      Tahun: new Date(values.Bulan).getFullYear().toString(),
      DetailAccount: values.DetailAccount,
    });
  };

  const handlePageChange = (newStart) => {
    const safeStart = Math.max(0, newStart);
    setStart(safeStart);
    setParam((prev) => ({ ...prev, start: safeStart }));
  };

  return (
    <>
      <div className="md:ml-64">
        <div
          style={{ background: Colors.primary }}
          className="pt-14 pb-16 px-3 md:px-8 h-auto"
        >
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
          </div>
        </div>
        <div className="px-3 md:px-8 h-auto -mt-32">
          <div className="container mx-auto max-w-full">
            <div className="grid grid-cols-1 px-4">
              <Card>
                <div className="flex flex-row flex-wrap items-start justify-start w-full px-2 py-2">
                  <div className={"w-1/4"}>
                    <HrdInputGenerator
                      type={"bulan"}
                      name={"Bulan"}
                      title={"Bulan"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>
                  <div className={"w-1/4"}>
                    <HrdInputGenerator
                      type={"DetailAccount"}
                      name={"DetailAccount"}
                      title={"COA"}
                      value={values}
                      required={true}
                      onChange={customHandler}
                      touched={touched}
                      errors={errors}
                      size={"full"}
                    />
                  </div>

                  <div className={"w-1/4"}>
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2">
                      Buka data
                    </label>

                    <button
                      type="button"
                      onClick={filterApi}
                      className=" text-main-100 hover:text-white border border-main-100 hover:bg-main-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2 text-center mr-2 mb-2 "
                    >
                      Buka
                    </button>
                  </div>
                </div>

                <div className="flex flex-col items-center content-center ">
                  <BukuBankReportTable
                    data={mutationData.data}
                    bulan={param.Bulan}
                    tahun={param.Tahun}
                    detailAccount={param.DetailAccount}
                    pageSize={count}
                    start={param.start}
                    onPageChange={handlePageChange}
                    name={"Nama"}
                    title={"Report Buku Bank"}
                  />
                </div>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReportBukuBank;
